<template>
    <aside v-if="isAdmin" class="magico-navbar js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered bg-white  ">
        <div class="navbar-vertical-container">
            <div class="navbar-vertical-footer-offset">
                <!-- Navbar Vertical Toggle -->
                <button ref="btnToogler" type="button" class="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
                    <i class="bi-arrow-bar-left navbar-toggler-short-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Collapse"></i>
                    <i class="bi-arrow-bar-right navbar-toggler-full-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Expand"></i>
                </button>
                <!-- End Navbar Vertical Toggle -->
                <!-- Content -->
                <div class="navbar-vertical-content">
                    <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
                         <div v-if="isAdmin" class="nav-item">
                            <router-link to="/" class="nav-link " :class="{active:$route.meta.menu=='group'}" data-placement="left">
                                <i class="bi-building nav-icon"></i>
                                <span class="nav-link-title">Kokpit</span>
                            </router-link>
                        </div>
                        <!-- Collapse -->
                        <!-- End Collapse -->
                        <!-- <span v-if="isAdmin" class="dropdown-header mt-4">{{$lang.config}}</span> -->
                        <small v-if="isAdmin" class="bi-three-dots nav-subtitle-replacer"></small>
                        <!-- <div v-if="isAdmin" class="nav-item">
                            <router-link to="/client" class="nav-link " :class="{active:$route.meta.menu=='client'}" data-placement="left">
                                <i class="bi-building nav-icon"></i>
                                <span class="nav-link-title">Klienci API</span>
                            </router-link>
                        </div> -->
                        <div v-if="isAdmin" class="nav-item">
                            <router-link to="/sites" class="nav-link " :class="{active:$route.meta.menu=='sites'}" data-placement="left">
                                <i class="bi-building nav-icon"></i>
                                <span class="nav-link-title">Strony Cms</span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- End Content -->
                <!-- Footer -->
                <div class="navbar-vertical-footer">
                    <ul class="navbar-vertical-footer-list">
                        <li class="navbar-vertical-footer-list-item">
                            <!-- Style Switcher -->
                            <color-switcher></color-switcher>
                            <!-- End Style Switcher -->
                        </li>
                     <!--    <li class="navbar-vertical-footer-list-item">
                            <div class="dropdown dropup">
                                <button type="button" class="btn btn-ghost-secondary btn-icon rounded-circle" id="otherLinksDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-dropdown-animation>
                                    <i class="bi-info-circle"></i>
                                </button>
                                <div class="dropdown-menu navbar-dropdown-menu-borderless" aria-labelledby="otherLinksDropdown">
                                    <span class="dropdown-header">Help</span>
                                    <a class="dropdown-item" href="#">
                                        <i class="bi-journals dropdown-item-icon"></i>
                                        <span class="text-truncate" title="Resources &amp; tutorials">Resources &amp; tutorials</span>
                                    </a>
                                    <a class="dropdown-item" href="#">
                                        <i class="bi-command dropdown-item-icon"></i>
                                        <span class="text-truncate" title="Keyboard shortcuts">Keyboard shortcuts</span>
                                    </a>
                                    <a class="dropdown-item" href="#">
                                        <i class="bi-alt dropdown-item-icon"></i>
                                        <span class="text-truncate" title="Connect other apps">Connect other apps</span>
                                    </a>
                                    <a class="dropdown-item" href="#">
                                        <i class="bi-gift dropdown-item-icon"></i>
                                        <span class="text-truncate" title="What's new?">What's new?</span>
                                    </a>
                                    <div class="dropdown-divider"></div>
                                    <span class="dropdown-header">Contacts</span>
                                    <a class="dropdown-item" href="#">
                                        <i class="bi-chat-left-dots dropdown-item-icon"></i>
                                        <span class="text-truncate" title="Contact support">Contact support</span>
                                    </a>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
                <!-- End Footer -->
            </div>
        </div>
    </aside>
</template>
<script>
import HSSideNav from 'Front-Dashboard/src/assets/vendor/hs-navbar-vertical-aside/dist/hs-navbar-vertical-aside.js'
import  ColorSwitcher from './ColorSwitcher.vue'
export default {
    name: 'Sidebar',
    components:{ColorSwitcher},
    computed: {
        isAdmin: function() {
            return ['owner', 'manager'].includes(this.$store.getters['app/role'])
        },
    },
    data: function() {
        return {
            isShow: true,
        }
    },
    methods: {
    },
    mounted() {
        if (!this.isAdmin) {
            console.log('no admin');
            document.body.classList.remove('navbar-vertical-aside-show-xl');
        } else {
            let vm = this;
            if (vm.$refs.btnToogler) {
                setTimeout(function() {
                    vm.$refs.btnToogler.style.opacity = 1;
                }, 500);
            }
            new HSSideNav('.js-navbar-vertical-aside').init();

        }
    }
}
</script>